import React, { useState, useEffect } from 'react';
import AccountSettingSidebar from "../../../../component/common/layout/AccountSettingSidebar";
import LeftSidebarNew from "../../../../component/common/layout/LeftSidebarNew";
import SurveyListHeader from "../../../../component/common/layout/SurveyListHeader";
import Svg from "../../../../component/common/Svg";
import Input from "../../../../core/Inputs/DefaultInput";

import { Formik } from "formik";

import CreatableSelect from "react-select/creatable";
import SurveyListSidebar from "../../../../component/common/layout/SurveyListSidebar";
import { Link, useNavigate } from "react-router-dom";
import { createTeamSchema } from "../../../../schema/team";
import { addTeam } from "../../../../store/actions/teamAction";
import { useDispatch, useSelector } from "react-redux";
import NestedMenuToggle from "../NestedMenuToggle";
import { useTranslation } from 'react-i18next';
import {getTeamList} from "../../../../store/actions/teamAction";
import { getCountryCodes } from "../../../../store/actions/locationActions";
import { toast } from "react-toastify";

export default function Create() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { t, i18n } = useTranslation();
  const { countryCodesData } = useSelector((state) => state.locationData);
  const [serverParams, setServerParams] = useState({
    startingLimit: 0,
    resultsPerPage: 8,
    search: "",
    sort_by: "team_name",
    sort_order: "asc",
  });

  useEffect(() => {
    dispatch(getCountryCodes());
  }, []);

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
        <SurveyListHeader />
        <div id="viewport" className="d-flex bg-white">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 page-content-wrap d-flex flex-column">
              <div className="page-heading">
                {/* breadcrumbs here */}
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">{t('settings.title')}</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/user-permissions">{t('settings.users_and_teams.breadcrumb_heading')}</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/teams/list">{t('settings.team.heading')}</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>{t('settings.team.create_team.heading')}</strong>
                    </li>
                  </ol>
                </nav>
                {/* breadcrumbs ends here */}
                <div className="d-flex align-items-center">
                  <NestedMenuToggle />
                  <div className="flex-grow-1 ps-3 ps-lg-0">
                    <h1>{t('settings.team.create_team.heading')}</h1>
                  </div>
                </div>
              </div>
              <div className="role-wrapper flex-grow-1">
                <Formik
                  initialValues={{
                    team_name: "",
                    is_active: "1",
                    country: "",
                    country_code: "",
                  }}
                  enableReinitialize
                  validationSchema={createTeamSchema}
                  onSubmit={async (values, { setSubmitting, resetForm }) => {
                    const dataToSend = {
                      team_name: values.team_name,
                      is_active: values.is_active,
                      country: values.country,
                      country_code: values.country_code,
                    };
                    try {
                      const result = await dispatch(addTeam(dataToSend));
                      if (result?.success) {
                        toast.success(result.msg || "Team added successfully");
                        resetForm();
                        dispatch(getTeamList(serverParams));
                        navigate("/admin/settings/teams/list");
                      } else {
                        toast.error(result?.msg || "Failed to create team");
                      }
                    } catch {
                      toast.error("Failed to create team");
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    resetForm,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="create-team-form">
                        <div className="row">
                          <div className="col-lg-6  position-relative">
                            <div className="form-group mb-3">
                              <label>{t('settings.team.action.team_name')}<span className="text-primary">*</span>
                              </label>
                              <Input
                                type="text"
                                view="outlined"
                                dense={false}
                                name="team_name"
                                color="default"
                                label=""
                                placeholder={t('settings.team.action.team_name')}

                                clearButton={true}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                defaultValue={values.team_name}
                                onChange={handleChange}
                              />
                            </div>
                            {touched.team_name && errors.team_name && (
                              <div className="validation-msg">
                                {errors.team_name}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 position-relative">
                            <div className="form-group mb-3">
                              <label>Country<span className="text-primary">*</span></label>
                              <select
                                name="country"
                                className="form-control formsinput"
                                value={values.country}
                                onChange={(e) => {
                                  const selectedName = e.target.value;
                                  setFieldValue("country", selectedName);
                                  const match = Array.isArray(countryCodesData)
                                    ? countryCodesData.find((c) => c.name === selectedName)
                                    : null;
                                  setFieldValue("country_code", match ? `+${match.countrycode}` : "");
                                }}
                                onBlur={handleBlur}
                              >
                                <option value="">Select Country</option>
                                {Array.isArray(countryCodesData) &&
                                  countryCodesData
                                    .slice()
                                    .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                                    .map((c, idx) => (
                                      <option key={`${c.name}-${c.alpha2}-${idx}`} value={c.name}>
                                        {c.name}
                                      </option>
                                    ))}
                              </select>
                            </div>
                            {touched.country && errors.country && (
                              <div className="validation-msg">
                                {errors.country}
                              </div>
                            )}
                          </div>
                          <div className="col-lg-6 position-relative">
                            <div className="form-group mb-3">
                              <label>Country Code</label>
                              <input
                                type="text"
                                className="form-control formsinput"
                                name="country_code"
                                value={values.country_code}
                                readOnly
                                placeholder="Auto-filled"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="button-wrap d-flex">
                          <button type="submit" className="btn btn-primary">
                          {t('settings.team.action.save')}

                          </button>
                          {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                          {/* <button type="button" className="btn btn-primary">Save</button> */}
                          <button
                            type="button"
                            className="btn btn-bordered ms-3"
                            onClick={() => {
                              navigate("/admin/settings/teams/list");
                            }}
                          >
                           {t('settings.team.action.cancel')}

                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
